import { COUNTRY_NAME_IT } from "@/lib/countryCapitals";

/* Il Paese accanto a un luogo citato («Novi Sad · Serbia» nella tavola
   «Notizia riservata»). A monte una voce `wiki` di tipo City porta solo il
   nome, senza il suo Paese (verificato il 15/10/2026 su OI-353578), e
   dedurlo dai Paesi del dispaccio sbaglia: lo stesso pezzo cita «Mosca»
   e ha per Paese la Serbia. Quindi il Paese si scrive solo quando lo si
   sa davvero:

   - il luogo è a sua volta un Paese → «Paese», come nella tavola;
   - il luogo è una capitale → il suo Paese. La tabella è quella dei
     commenti di `CAPITALS` in lib/countryCapitals.ts (le capitali della
     mappa), scritta qui per esteso perché un commento non si legge a
     runtime: se lì entra una capitale nuova, va aggiunta anche qui;
   - altrimenti niente: il nome resta solo. */
const CAPITALE_ISO: Record<string, string> = {
  "Roma": "IT",
  "Parigi": "FR",
  "Berlino": "DE",
  "Madrid": "ES",
  "Lisbona": "PT",
  "Londra": "GB",
  "Dublino": "IE",
  "Amsterdam": "NL",
  "Bruxelles": "BE",
  "Lussemburgo": "LU",
  "Vienna": "AT",
  "Berna": "CH",
  "Varsavia": "PL",
  "Praga": "CZ",
  "Bratislava": "SK",
  "Budapest": "HU",
  "Bucarest": "RO",
  "Sofia": "BG",
  "Atene": "GR",
  "Ankara": "TR",
  "Nicosia": "CY",
  "La Valletta": "MT",
  "Zagabria": "HR",
  "Lubiana": "SI",
  "Belgrado": "RS",
  "Sarajevo": "BA",
  "Tirana": "AL",
  "Skopje": "MK",
  "Podgorica": "ME",
  "Pristina": "XK",
  "Copenaghen": "DK",
  "Stoccolma": "SE",
  "Oslo": "NO",
  "Helsinki": "FI",
  "Tallinn": "EE",
  "Riga": "LV",
  "Vilnius": "LT",
  "Minsk": "BY",
  "Kiev": "UA",
  "Mosca": "RU",
  "Astana": "KZ",
  "Baku": "AZ",
  "Washington": "US",
  "Ottawa": "CA",
  "Città del Messico": "MX",
  "Panama": "PA",
  "Brasilia": "BR",
  "Buenos Aires": "AR",
  "Pechino": "CN",
  "Tokyo": "JP",
  "Seoul": "KR",
  "Nuova Delhi": "IN",
  "Islamabad": "PK",
  "Dacca": "BD",
  "Kabul": "AF",
  "Teheran": "IR",
  "Baghdad": "IQ",
  "Gerusalemme": "IL",
  "Ramallah": "PS",
  "Damasco": "SY",
  "Beirut": "LB",
  "Amman": "JO",
  "Riyadh": "SA",
  "Abu Dhabi": "AE",
  "Doha": "QA",
  "Kuwait City": "KW",
  "Mascate": "OM",
  "Sana'a": "YE",
  "Tripoli": "LY",
  "Il Cairo": "EG",
  "Algeri": "DZ",
  "Tunisi": "TN",
  "Rabat": "MA",
  "Khartoum": "SD",
  "Addis Abeba": "ET",
  "Nairobi": "KE",
  "Abuja": "NG",
  "Yamoussoukro": "CI",
  "Pretoria": "ZA",
  "Hanoi": "VN",
  "Singapore": "SG",
  "Giacarta": "ID",
  "Bangkok": "TH",
  "Manila": "PH",
  "Kuala Lumpur": "MY",
  "Canberra": "AU",
  "Wellington": "NZ",
};

const PAESI = new Set(Object.values(COUNTRY_NAME_IT).map((n) => n.toLowerCase()));

export function paeseDelLuogo(nome: string): string | null {
  const n = nome.trim();
  if (PAESI.has(n.toLowerCase())) return "Paese";
  const iso = CAPITALE_ISO[n];
  return iso ? (COUNTRY_NAME_IT[iso] ?? null) : null;
}
